import { AttributeFieldProps } from "./RenderAttributeInput";
import ButtonField from "./ButtonsField";
import { AttributeTargetType } from "../Data/WBData";

export default function FlexDirField(props:AttributeFieldProps){

    const updateFunc = props.updateFunc;

    const onUpdate=(attribute:string,value:string,targetType:AttributeTargetType)=>{
      

        updateFunc("justifyContent","",AttributeTargetType.Style);
        updateFunc("alignContent","",AttributeTargetType.Style);
        updateFunc("alignItems","",AttributeTargetType.Style);
        updateFunc(attribute,value,targetType);
        props.saveFunc();
    }

   return (
     <ButtonField {...props} updateFunc={onUpdate} />
   );

}